
import HeaderComponent from "@/components/HeaderComponent.vue";
import SideNav from "@/components/SideNav.vue";
import LocaleSwitcher from "@/components/LocaleSwitcher.vue";
import AcceptCguDialog from "@/components/AcceptCguDialog.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import Snackbar from "@/components/Snackbar.vue";
import MyBanner from "@/components/myBanner.vue";
import Activity from "@/components/Activity.vue";
import EnvCompanySelect from "@/components/company/EnvCompanySelect.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { CGU_LINK } from "@/utils/constants";
import {
  mdiContentDuplicate,
  mdiLogout,
  mdiAccountKey,
  mdiBlockHelper,
  mdiQrcodeScan,
  mdiEmailOutline,
  mdiBellOutline,
  mdiKey,
  mdiCalendar,
  mdiStore,
  mdiContacts,
  mdiPlayBox,
} from "@mdi/js";
import SetCredentials from "@/views/SetCredentials.vue";
import {formRules} from "@/utils/formRules";
import { getBrowserVersion } from "@/utils/navigator/userAgent";
import HeaderNotifications from "@/components/HeaderNotifications.vue";

@Component({
  components: {
    EnvCompanySelect,
    Snackbar,
    HeaderComponent,
    SideNav,
    LocaleSwitcher,
    AcceptCguDialog,
    MyBanner,
    Activity,
    SvgIcon,
    SetCredentials,
    HeaderNotifications,
  },
})
export default class App extends Vue {

  get invitationBy(): string | undefined {
    return this.$store.state.auth.invitationBy;
  }
  get currentUserId() {
    return this.currentUser.id;
  }
  get hasUserEmail(): boolean {
    return formRules.isEmail(this.currentUser?.email);
  }
  get cguNotAccepted(): boolean {
    return this.isDemo && !this.hasAcceptedCgu && this.$route.fullPath !== "/general-terms";
  }

  get isMobile() {
      return this.windowWidth <= 600;
  }

  @Getter private mylobyEnv: string;

  private displayProfile: boolean = false;
  private windowWidth: number = 1000;
  private showSetEmailForm: boolean = false;
  private MAX_ITEM_NAV_FOOTER: number = 5;
  private CGU_LINK = CGU_LINK;
  private tutorials = {
      name: "tutorials",
      label: "nav.tutorialsMyloby",
      iconPath: "mdiPlayBox",
    };

  private icons = {
    mdiContentDuplicate,
    mdiLogout,
    mdiAccountKey,
    mdiBlockHelper,
    mdiQrcodeScan,
    mdiEmailOutline,
    mdiBellOutline,
    mdiKey,
    mdiCalendar,
    mdiStore,
    mdiAccountGroup: mdiContacts,
    mdiPlayBox,
  };

  @Getter private isDemo: boolean;
  @Getter private currentUser: any;
  @Getter private isAdmin: boolean;
  @Getter private hasAcceptedCgu: boolean;
  @Getter private envCompanyId: number|null;
  @Getter("getMobileNavItemList", { namespace: "nav" }) private mobileNavItemList: any[];

  public metaInfo() {
    return {
      meta: [
        { name: "robots", content: "noindex, nofollow" },
        { name: "googlebot", content: "noindex" },
      ],
    };
  }

  public fetchPathByLabel(label) {
    if (this.icons[label]) {
      return this.icons[label];
    } else {
      // tslint:disable-next-line:no-console
      console.error("Maybe you forgot to import icon path: " + label);
      return this.icons.mdiBlockHelper;
    }
  }

  @Watch("$route", { immediate: true, deep: true })
  public handlerRouter() {
    this.$store.commit("mobileMenu", true);
  }

  private mounted(): void {
    this.updateIsPwa();
    this.updateBrowserVersion();
    this.updateWindowWidth();
    window.addEventListener("resize", this.updateWindowWidth);
  }

  private logout(): void {
    this.displayProfile = false;
    this.$store.dispatch("auth/logout");
  }

  private updateWindowWidth(): void {
    this.windowWidth = document.documentElement.clientWidth;
    this.$store.commit("dispatchIsMobile", this.isMobile);
  }

  private updateBrowserVersion(): void {
    const browserVersion = getBrowserVersion();
    this.$store.commit("dispatchBrowserVersion", browserVersion);
  }

  private updateIsPwa(): void {
    const isPwa: boolean = window.matchMedia("(display-mode: standalone)").matches;
    this.$store.commit("dispatchIsPwa", isPwa);
  }

  private refresh(): void {
    window.location.reload();
  }
}
